function checkIfMobileScreenSize(){
    return $(window).width()<767;
}
function isEditMode(){
    return $('body').hasClass("editmode");
}

// Equalize columns
function equalizeHeights(selector, subselector) {
    Foundation.utils.image_loaded($('img.wait-for-me'), function(){
        if(checkIfMobileScreenSize() != true && !$("body").hasClass("editmode")){
            $(selector).each(function () {
                var current = $(this);
                var heights = new Array();
                current.find(subselector).each(function () {
                    $(this).css('min-height', '0');
                    $(this).css('max-height', 'none');
                    $(this).css('height', 'auto');
                    heights.push($(this).outerHeight());
                });
                var max = Math.max.apply(Math, heights);
                current.find(subselector).css('height', max + 'px');
            });
        }
        if(checkIfMobileScreenSize() != false && !$("body").hasClass("editmode")){
            $(selector).find(subselector).each(function() {
                $(this).css('height', 'auto');
            });
        }
    });
}

$(document).ready(function() {
    cookieConsent();
    initiateMobileAnchors();
    initializeDateRangeInputs();

    //used for modal vimeo player in html comp
    const panelWithModal = document.querySelector('.panel:has(#modalVimeo)');
    if (panelWithModal) {
        document.querySelectorAll('.panel:has(#modalVimeo)').forEach(p => p.style.padding=0)
    }
})

$(window).load(function() {
    if($(".row").hasClass("equalize")) {
        equalizeHeights("#mainContentContainer .row.equalize", ".panel");
        equalizeHeights("#footer .row.equalize .panel",".columns");
        $(window).resize(function() {
            setTimeout(function() {
                equalizeHeights("#mainContentContainer .row.equalize", ".panel");
                equalizeHeights("#footer .row.equalize .panel",".columns");
            }, 100);
        });
    }

    $('.panel').each((i, e) => {
        const components = $(e).find('.is-component');
        if ($(components[components.length - 1]).hasClass('image-only')) {
            $(components[components.length - 1]).css('margin-top', '1.3rem');
        }
    })

    if ($('#signupForm').length > 0) {

        $('#signupForm')[0].addEventListener('freeform-ready', function () {
            $('input[name=stipendium]').on('click', setUploadButtonText);
            $('input[name=stipendium]').on('click', setSelectedGrant);
            $('.form-select').on('change', filterOptions);
        });

        if (window != window.parent) {
            $('#signupForm a').on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window.parent.postMessage($(e.currentTarget).attr('href'), '*');
                return false;
            });
        }
    }

    if ($('.breadcrumbs').length > 0) {
        setAnchorsWidth();
        window.addEventListener('resize', setAnchorsWidth);
    }

    if ($('form[data-handle="studioBookingForm"]').length > 0) {
        setTimeout(() => {
            flatpickr('#form-input-endDateBooking', {
                'disableMobile': true,
                'locale': $('#form-input-endDateBooking').attr('data-datepicker-locale'),
                'dateFormat': $('#form-input-endDateBooking').attr('data-datepicker-format'),
                'allowInput': false,
                'dateFormat': 'd.m.Y'                
            });
            flatpickr('#form-input-startDateBooking', {  
                'disableMobile': true,
                'locale': $('#form-input-startDateBooking').attr('data-datepicker-locale'),
                'dateFormat': $('#form-input-startDateBooking').attr('data-datepicker-format'),              
                'allowInput': false,
                'dateFormat': 'd.m.Y'                 
            });
        }, 700);
        
    }

    $('.anchor-menu-item').on('click', (e) => {
        $('.anchor-menu-item').each((i, el) => {
            $(el).removeClass('active');
        });
        $(e.currentTarget).addClass('active');
    })
    $('.anchor-menu-item').each((i, el) => {
        $(el).removeClass('active');
        
        if ($(el).children('a').attr('href') == window.location.hash) {
            $(el).addClass('active');
        }
    });

    let eventContainer = document.querySelectorAll('.type-event');
    eventContainer.forEach((item, index) => {
        (index % 2 == 0) ?item.parentElement.classList.add('theme-grey-light'):item.parentElement.classList.add('theme-red')
    });
});

function setAnchorsWidth() {
    let minW = 10000;
    $('.breadcrumbs > li').attr('style', '');
    $('.breadcrumbs').find('li').each((i, e) => {
        if (minW > $(e).width()) {
            minW = $(e).width();
        }
    });

    $('.breadcrumbs').find('li').each((i, e) => {
        if (minW < $(e).width()) {
            $(e).css('max-width', minW);
        }
    })
}

function setUploadButtonText(e) {
    const texts = {
        'Bildende Kunst': 'form-input-uploadBildendeText',
        'Mode & Textil': 'form-input-uploadModeText',
        'Tanz / Performing Arts': 'form-input-uploadTanzText',
        'Literatur': 'form-input-uploadLiteraturText',
        'Recherchestipendium für Kuratierende, Kunstkritiker*innen und Kulturvermittelnde': 'form-input-uploadRechercheText',
        'Recherchestipendium für Kuratierende, Kunstkritiker*innen und Kulturvermittelnde': 'form-input-uploadRechercheText',
    };
    if (e.target.value == 'Recherchestipendium für Kuratierende, Kunstkritiker*innen und Kulturvermittelnde') {
        if (!$('label[for=form-input-motivationsschreiben]').attr('data-original')) {
            $('label[for=form-input-motivationsschreiben]').attr('data-original', $('label[for=form-input-motivationsschreiben]').html());
        }
    
        $('label[for=form-input-motivationsschreiben]').html($('#form-input-uploadRecherchestipendiumText').val())
    } else {
        if ($('label[for=form-input-motivationsschreiben]').attr('data-original')) {
            $('label[for=form-input-motivationsschreiben]').html($('label[for=form-input-motivationsschreiben]').attr('data-original'));
        }
    }
    $('label[for=form-input-cvUndKunstlerInnenDossier]').html($('#' + texts[e.target.value]).val())
}

function setSelectedGrant(e) {
    const label = $(e.target).siblings('label').text();
    if (label.indexOf('Recherche') > -1 || label.indexOf('Research') > -1) {
        $('#baliLink').hide();
    } else {
        $('#baliLink').show();
    }
    let href = '';
    if (label.indexOf('Bildend') > -1 || label.indexOf('Arts') > -1 || label.indexOf('Visual') > -1) {
        href = $('#infoPdf').attr('data-bk');
    }
    if (label.indexOf('Tanz') > -1 || label.indexOf('Danse') > -1 || label.indexOf('Dance') > -1 ) {
        href = $('#infoPdf').attr('data-tanz');
    }
    if (label.indexOf('Mode') > -1 || label.indexOf('Fashion') > -1) {
        href = $('#infoPdf').attr('data-mode');
    }
    if (label.indexOf('Literatur') > -1 || label.indexOf('Litt') > -1) {
        href = $('#infoPdf').attr('data-literatur');
    }
    if (label.indexOf('Recherche') > -1 || label.indexOf('Recherche') > -1 || label.indexOf('Research') > -1) {
        href = $('#infoPdf').attr('data-recherche');
        $('#selectedGrant').html('<a target="_blank" href="' + href + '">' + label + '</a>');
    } else {
        $('#selectedGrant').html('<a target="_blank" href="' + href + '">' + label + '</a>');
    }
    setTimeout(() => {
        if (window != window.parent) {
            $('#signupForm a').on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window.parent.postMessage($(e.currentTarget).attr('href'), '*');
                return false;
            });
        }
    }, 10);
}

function filterOptions(e) {
    const commonName = e.target.id.slice(0, -1);
    const selectedOptions = [];
    $('.form-select[id^=' + commonName + ']').each((i, e) => {
        if ($(e).find(':selected').val() != '') {
            selectedOptions.push($(e).find(':selected').val());
        }
    });
    $('.form-select[id^=' + commonName + ']').each((i, e) => {
        //if ($(e).find(':selected').val() == '') {
            $(e).find('option').show();
            selectedOptions.forEach(value => {
                $(e).find('[value="' + value + '"]').hide();
            })
        //}
    });
}

function resizeContent() {
    var scHeight = $(window).height()-$("#header").outerHeight()-$("#brand").outerHeight()-$("#cmsb").outerHeight();
    if(!$("body").hasClass("editmode")) {
        $('#stageContainer').css({"height": scHeight + "px"});
    }
}

// Navigation
$(function() {
    var n = "#menu";
    // Touch detection
    $(n).find("li:has(ul)").doubleTapToGo();
    // Navigation interaction
    $(document).ready(function(){
        var touch 	= $('#touch-menu');
        var menu 	= $('#navigation > ul,#meta > ul');
        var header  = $('#header');
        $(touch).on('click', function(e) {
            e.preventDefault();
            menu.slideToggle("fast");
            //Sticky menu bar         
            //header.addClass('sticky opened');    
            if(header.hasClass("opened")){                
                header.removeClass("opened");
            }else{                
                header.addClass("opened");
            }
        });
        $(window).resize(function(){
            var w = $(window).width();
            if(w > 767 && menu.is(':hidden')) {
                menu.removeAttr('style');
            }
        });
        //Sticky menu bar
        var oldScrollY = window.scrollY;
        window.addEventListener('scroll', function() {  
     
            if(oldScrollY  < window.scrollY && !header.hasClass("opened") ){
                    header.addClass('non-sticky');
                    header.removeClass('sticky');                    
                } else {
                    header.addClass('sticky');
                    header.removeClass('non-sticky');                      
                }
            oldScrollY = window.scrollY;
        });
    });
});




/*
 By Osvaldas Valutis, www.osvaldas.info
 Available for use under the MIT License
 */
 ;(function(e,t,n,r){e.fn.doubleTapToGo=function(r){if(!("ontouchstart"in t)&&!navigator.msMaxTouchPoints&&!navigator.userAgent.toLowerCase().match(/windows phone os 7/i))return false;this.each(function(){var t=false;e(this).on("click",function(n){var r=e(this);if(r[0]!=t[0]){n.preventDefault();t=r}});e(n).on("click touchstart MSPointerDown",function(n){var r=true,i=e(n.target).parents();for(var s=0;s<i.length;s++)if(i[s]==t[0])r=false;if(r)t=false})});return this}})(jQuery,window,document);
//Anchor scroll
 $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    var target = $($.attr(event.currentTarget, 'href'));
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 500);
    }
    //$('html, body').animate({
    //     scrollTop: $($.attr(event.currentTarget, 'href')).offset().top
    //}, 500);
});

// Cookie Consent message
function cookieConsent() {

    var cookieConsentText = $("<textarea/>").html(getBaseSetting('cookieConsentText', '')).text(),
        cookieConsentAcceptButtonText = getBaseSetting('cookieConsentAcceptButtonText', 'Zulassen'),
        cookieConsentDeclineButtonText = getBaseSetting('cookieConsentDeclineButtonText', 'Ablehnen');

    if (cookieConsentText !== '') {
        window.cookieconsent.initialise({
            type: "opt-in",
            theme: "classic",
            revokable: false,
            content: {
                link: "",
                href: "",
                message: cookieConsentText
            },
            elements: {
                dismiss: '<a aria-label="dismiss cookie message" tabindex="0" class="cc-btn cc-dismiss button secondary">' + cookieConsentDeclineButtonText + '</a>',
                allow: '<a aria-label="allow cookies" tabindex="0" class="cc-btn cc-allow button">' + cookieConsentAcceptButtonText + '</a>',
                deny: '<a aria-label="deny cookies" tabindex="0" class="cc-btn cc-deny button secondary">' + cookieConsentDeclineButtonText + '</a>',
                close: '<span aria-label="dismiss cookie message" tabindex="0" class="cc-close">' + cookieConsentDeclineButtonText + '</span>'
            },
            onInitialise: function (status) {
                if (status === cookieconsent.status.allow) {
                    enableTrackingCookies();
                }
            },
            onStatusChange: function (status) {
                if (this.hasConsented()) {
                    enableTrackingCookies();
                }
            }
        });
    }

    function enableTrackingCookies() {
        /* scripts that have data cookieconsent=true will be reinitialized */
        $('script').each(function (i, script) {
            if ($(script).data('cookieconsent') === true) {
                $(script).after('<script type="text/javascript" ' + ($(script).attr('src') ? 'src="' + $(script).attr('src') + '"' : '') + ' >' + $(script).html() + '</script>');
                $(script).remove();
            }
        });
    }
}

 //Function to add/ remove classes on mobile anchors according to their state
 function checkActiveAnchorsMobile() {
          
    const pageUrlString = window.location.href;
    const liElements = $('.mobile-anchor-menu-item');
    
    liElements.each(function() {
      const anchorElement = $(this).find('a');
      const liElement = $(this);

      const parentElement = liElement.parent();
      const siblingAnchor = parentElement.siblings('a.active');
           
      liElement.removeClass('previous-active');                                              

      if (anchorElement.length > 0) {
        if (anchorElement.attr('href') === pageUrlString) { 
          parentElement.siblings('span.arrowHolder').removeClass('hasDownChild');
          parentElement.siblings('span.arrowHolder').addClass('hasUpChild');     
          parentElement.siblings('span.arrowHolder').find('i.anchorArrow').removeClass('down');
          parentElement.siblings('span.arrowHolder').find('i.anchorArrow').addClass('up');
          anchorElement.addClass('active');
          liElement.addClass('active');
          liElement.prev().addClass('previous-active'); 
          siblingAnchor.removeClass('active');
          siblingAnchor.addClass('activeWithAnchor');
        } else {        
          liElement.removeClass('active');
          anchorElement.removeClass('active');
        }                  
      }
    });
}

function initiateMobileAnchors(){
    //make click on mobile nav link work on the first time
    $('#navigation a').click(function(event) {
      event.stopPropagation();          
    });

    window.addEventListener("hashchange", checkActiveAnchorsMobile);

    //retract whole menu dropdown after anchor click
    $('.mobileAnchors a').click(function(event) {
       event.stopPropagation();
      var header  = $('#header');
     
      $('#navigation > ul,#meta > ul').slideUp(400 ,function(){
            header.removeClass("opened");
      });          
    });

    //Mobile navigation - anchor dropdown up/down pointing arrow
    $('.arrowHolder').on('click touchstart', function(e) {
       if (e.cancelable){
           e.preventDefault();
       }  
         $(this).find('.anchorArrow').toggleClass('down up')
         $(this).next('.mobileAnchors').slideToggle();  

        $('.arrowHolder').each(function() {
          if($(this).find('.up').length) {
            $(this).removeClass('hasUpChild');
            $(this).removeClass('hasDownChild');
            $(this).addClass('hasUpChild');              
          }
          if($(this).find('.down').length) {
            $(this).removeClass('hasUpChild');
            $(this).removeClass('hasDownChild');
            $(this).addClass('hasDownChild');              
          }
        });

     });
    

    // IF active menu link has anchors, display list of anchors by default and add proper style to the parent menu
    if($('#navigation > ul > li > a.active').siblings('ul.mobileAnchors').length > 0) { 

      const siblingUl = $('#navigation > ul > li > a.active').siblings('ul.mobileAnchors');
      if($('#navigation > ul > li > a.active').siblings('span.hasDownChild').length > 0) { 
        $('#navigation > ul > li > a.active').siblings('span.hasDownChild').removeClass('hasDownChild').addClass('hasUpChild');
        $('#navigation > ul > li > a.active').siblings('span.hasUpChild').find('i.down').removeClass('down').addClass('up');
      }

      siblingUl.css('display', 'block');

      if( $('#navigation > ul > li > a.active').siblings('ul.mobileAnchors > li.active')){            
          $('#navigation > ul > li > a.active').addClass('activeWithAnchor');
          $('#navigation > ul > li > a.active').removeClass('active');
      }          
    } 

    //if main menu item has an anchor list with an active anchor -> add proper style to the main menu item
     if($('a.activeWithAnchor').siblings('ul.mobileAnchors').find('li.active').length == 0) {            
        $('a.activeWithAnchor').addClass('active');
        $('a.activeWithAnchor').removeClass('activeWithAnchor');
      } else {
        $('a.activeWithAnchor').addClass('activeWithAnchor');
        $('a.activeWithAnchor').removeClass('active');            
      }

     
     //run mobile anchors function on all mobile anchors items
     const liElements = document.querySelectorAll('.mobile-anchor-menu-item');
     liElements.forEach(li => {
        const anchorElement = li.querySelector('a');
        if (anchorElement) {                         
            anchorElement.addEventListener('click', checkActiveAnchorsMobile);
        }
      });
               
    checkActiveAnchorsMobile();
 }

 function initializeDateRangeInputs() {
    if (document.querySelectorAll('#periodInput').length > 0) {
        let inputs = document.querySelectorAll('#periodInput');
        let locales = {
            'en': {
                locale: 'en-US',
                dateFormat: 'MMM D YYYY',
                one: 'day',
                other: 'days',
                reset: '<svg width="32px" height="32px" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fill-rule="evenodd" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>Reset',
            },
            'de': {
                locale: 'de-DE',
                dateFormat: 'D. MMM. YYYY',
                one: 'Tag',
                other: 'Tage',
                reset: '<svg width="32px" height="32px" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fill-rule="evenodd" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>Zurücksetzen',
            },
            'fr': {
                locale: 'fr-FR',
                dateFormat: 'D MMM YYYY',
                one: 'jour',
                other: 'jours',
                reset: '<svg width="32px" height="32px" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fill-rule="evenodd" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>Réinitialiser',
            }
        };
        window.lightpicks = [];
        inputs.forEach((el) => {
            const maxDate = new Date();
            maxDate.setFullYear(maxDate.getFullYear() + 2)
            window.lightpicks.push({
                element: el,
                lightpickInstance: new easepick.create({
                    element: el,
                    css: [
                        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
                        "/assets/dist/app.css"
                    ],
                    zIndex: 10,
                    grid: 2,
                    calendars: 2,
                    RangePlugin: {
                        delimiter: " – ",
                        locale: {
                            one: locales[document.querySelector('html').getAttribute('lang')].one,
                            other: locales[document.querySelector('html').getAttribute('lang')].other,
                        },
                    },
                    LockPlugin: {
                        minDate: new Date(),
                        selectForward: true,
                        inseparable: true,
                        maxDate: maxDate,
                        minDays: 1,
                        maxDays: parseInt(window.calendarMaxDays),
                        filter(date, picked) {
                            return Object.keys(window.bookedEvents).includes(date.format('YYYY-MM-DD')) &&
                                window.bookedEvents[date.format('YYYY-MM-DD')] >= window.bookedEvents.count;
                        }
                    },
                    AmpPlugin: {
                        resetButton: true,
                        weekNumbers: true,
                        locale: {
                            resetButton: locales[document.querySelector('html').getAttribute('lang')].reset,
                        }
                    },
                    lang: locales[document.querySelector('html').getAttribute('lang')].locale,
                    format: locales[document.querySelector('html').getAttribute('lang')].dateFormat,
                    plugins: [
                        "RangePlugin",
                        "LockPlugin",
                        "AmpPlugin"
                    ]
                })
            })
        });
    }
 }

function isDateInRange(dateArray, dateRange) {
    // Convert the range boundaries to timestamps
    const rangeStart = dateRange[0].getTime();
    const rangeEnd = dateRange[1].getTime();

    // Iterate through the array of dates
    for (const dateString of dateArray) {
        const dateToCheck = new Date(dateString).getTime();

        // Check if the date falls within the range
        if (dateToCheck >= rangeStart && dateToCheck <= rangeEnd) {
            return true; // Date is within the range
        }
    }

    return false; // No date found within the range
}

 $(function() {
    $('#vimeoIframe').each(function() {
      var player = new Vimeo.Player(this);
      player.on('play', function() {
      });
    });
  });

